if (!customElements.get('testimonials-navigation')) {
  customElements.define('testimonials-navigation', class TestimonialsNavigation extends HTMLElement {
    constructor() {
      super();
      this.carousel = this.closest('carousel-slider');
      this.isMobile = window.innerWidth <= 989;
    }

    connectedCallback() {
      // Wait for carousel to be initialized
      this.init();
      
      // Listen for resize events to update mobile detection
      this.handleResize = () => {
        const wasMobile = this.isMobile;
        this.isMobile = window.innerWidth <= 989;
        
        // If mobile state changed, reinitialize
        if (wasMobile !== this.isMobile) {
          console.log('Testimonials pagination: Mobile state changed, reinitializing');
          this.init();
        }
      };
      
      window.addEventListener('resize', this.handleResize);
    }

    disconnectedCallback() {
      if (this.handleResize) {
        window.removeEventListener('resize', this.handleResize);
      }
    }

    init(retry = 1, maxRetry = 10) {
      console.log('Testimonials pagination: Init called, retry', retry, 'isMobile', this.isMobile);
      
      if (retry === maxRetry) {
        console.log('Testimonials pagination: Max retries reached');
        return;
      }

      // Check if we're on mobile and handle differently
      if (this.isMobile) {
        console.log('Testimonials pagination: Initializing mobile pagination');
        this.initMobilePagination();
        return;
      }

      if (!this.carousel || !this.carousel.flickity) {
        console.log('Testimonials pagination: Waiting for carousel, retry', retry);
        setTimeout(() => {
          this.init(retry + 1);
        }, 100);
        return;
      }

      console.log('Testimonials pagination: Initialized successfully');
      this.flickity = this.carousel.flickity;

      // Pagination dots
      const buttons = this.querySelectorAll('.testimonials-pagination-dot');
      console.log('Testimonials pagination: Found', buttons.length, 'dots');

      this.flickity.on('select', () => {
        console.log('Testimonials pagination: Slide changed to', this.flickity.selectedIndex);
        buttons.forEach(button => {
          button.classList.remove('is-active');
        });

        if (buttons[this.flickity.selectedIndex]) {
          buttons[this.flickity.selectedIndex].classList.add('is-active');
        }
      });

      buttons.forEach((button, index) => {
        button.addEventListener('click', () => {
          console.log('Testimonials pagination: Dot clicked, index', index);
          this.flickity.select(index);
        });
      });
    }

    initMobilePagination() {
      const buttons = this.querySelectorAll('.testimonials-pagination-dot');
      const scroller = this.carousel?.querySelector('.scroller-inner');
      
      if (!scroller || buttons.length === 0) {
        console.log('Testimonials pagination: Mobile elements not found');
        return;
      }

      console.log('Testimonials pagination: Mobile pagination initialized');

      // Handle scroll events for mobile
      let currentIndex = 0;
      const items = scroller.querySelectorAll('.grid-item');
      
      const updateActiveDot = (index) => {
        buttons.forEach(button => button.classList.remove('is-active'));
        if (buttons[index]) {
          buttons[index].classList.add('is-active');
        }
      };

      const updateActiveSlide = (index) => {
        // Remove is-selected class from all slides
        items.forEach(item => item.classList.remove('is-selected'));
        // Add is-selected class to current slide
        if (items[index]) {
          items[index].classList.add('is-selected');
        }
      };

      // Calculate item width based on actual item dimensions
      const getItemWidth = () => {
        if (items.length > 0) {
          const firstItem = items[0];
          return firstItem.offsetWidth + parseInt(getComputedStyle(firstItem).marginRight || 0);
        }
        return scroller.offsetWidth; // fallback
      };

      // Throttled scroll handler
      let scrollTimeout;
      scroller.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          const scrollLeft = scroller.scrollLeft;
          const itemWidth = getItemWidth();
          const newIndex = Math.round(scrollLeft / itemWidth);
          
          if (newIndex !== currentIndex && newIndex >= 0 && newIndex < items.length) {
            currentIndex = newIndex;
            updateActiveDot(currentIndex);
            updateActiveSlide(currentIndex);
            console.log('Testimonials pagination: Mobile slide changed to', currentIndex);
          }
        }, 100);
      });

      // Handle dot clicks for mobile
      buttons.forEach((button, index) => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          const itemWidth = getItemWidth();
          const targetScrollLeft = index * itemWidth;
          
          console.log('Testimonials pagination: Mobile dot clicked, index', index, 'scroll to', targetScrollLeft);
          
          // Use scrollTo with fallback for older browsers
          if (scroller.scrollTo) {
            scroller.scrollTo({
              left: targetScrollLeft,
              behavior: 'smooth'
            });
          } else {
            // Fallback for older browsers
            scroller.scrollLeft = targetScrollLeft;
          }
          
          currentIndex = index;
          updateActiveDot(currentIndex);
          updateActiveSlide(currentIndex);
        });
      });

      // Initial state
      updateActiveDot(0);
      updateActiveSlide(0);
      
      // Add resize handler to recalculate on orientation change
      window.addEventListener('resize', () => {
        // Recalculate on resize
        setTimeout(() => {
          const itemWidth = getItemWidth();
          const scrollLeft = scroller.scrollLeft;
          const newIndex = Math.round(scrollLeft / itemWidth);
          if (newIndex >= 0 && newIndex < items.length) {
            currentIndex = newIndex;
            updateActiveDot(currentIndex);
            updateActiveSlide(currentIndex);
          }
        }, 100);
      });
    }
  });
}
